<template>
  <div>
    <s-notification
      variant="danger"
      width="full"
      class="s-text-left s-text-sm"
      style="display: flex; flex-direction: column;"
    >
      Review and Resubmit these details
      <ul>
        <li v-for="error in errorCodes" :key="error.description">
          {{ error.description }}
        </li>
      </ul>
    </s-notification>
  </div>
</template>

<script>
export default {
  name: "ErrorCodeNotification",
  props: {
    errorCodes: {
      type: Array,
      required: true
    }
  },
};
</script>